import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[accordionTitle]',
    standalone: false
})
export class AccordionTitleDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
